import styled from "styled-components";

export const Container = styled.div`
    div:nth-child(2){
    }
`